export default ({ Factory, ApiServer }) => ({
  /**
   * Создание публикации
   * @param {Object} publication - публикация
   */
  create: (publication) => Factory.post(publication),

  /**
   * Обновление публикации
   * @param {Object} publication - публикация
   */
  update: (publication) => Factory.put(publication),

  /**
   * Удаление публикации
   * @param {String} id - идентификатор публикации
   */
  remove: (id) => Factory[id].delete(),

  /**
   * Получение списка публикаций(кратное)
   * @param {String} series - идентификатор серии(необязательное)
   */
  list: (series) => series ? Factory.list[series].get() : Factory.list.get(),

  /**
   * Получение списка типов
   */
  types: () => Factory.types.get(),

  /**
   * Получение списка статусов
   */
  statuses: () => Factory.statuses.get(),

  /**
   * Получение публикации(полное)
   * @param {String} id - идентификатор публикации
   */
  get: (id) => Factory[id].get(),

  /**
   * Получение списка шаблонов валидных ссылок на видео 
   */
  domens: () => Factory.domens.get(),

  /**
   * Получение файла
   * @param {*} publication - идентификатор публикации
   * @param {*} file        - идентификатор файла
   * @returns файл blob
   */
  file: (publication, file) => Factory[publication].file[file].blob(),

  /**
   * Получение идентификатора публикации по одному из параметров
   * @param {*} series  - идентификатор серии
   * @param {*} channel - идентификатор канала
   * @param {*} user    - идентификатор пользователя
   * @returns идентификатор публикации
   */
  find: (series, channel, user) => {
    if (series) return Factory.find[`?series=${series}`].get()
    else if (channel) return Factory.find[`?channel=${channel}`].get()
    else if (user) return Factory.find[`?user=${user}`].get()
    return null
  }
})